import { render, staticRenderFns } from "./FreeDay.vue?vue&type=template&id=f2faebe6&"
import script from "./FreeDay.vue?vue&type=script&lang=js&"
export * from "./FreeDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports